import React, { PureComponent, Component } from "react";
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Modal from "../../../../components/UI/Modal/Modal";
import { Table, ModalHeader, ModalBody, ModalFooter, Row, Col, Button } from 'reactstrap';
import ZigramTableView from "./ZigramTableView";
import { toast, ToastContainer } from 'react-toastify';
import _ from "lodash";

const CLOSE = "CLOSE";
const SUBMIT = "SUBMIT";
const CANCEL = "CANCEL";
const PROCEED = "PROCEED";

class ZigramModel extends Component {

    state = { zigramData: null, confirmModal: false, modalMessage: "", type: "", modalheader: "", resizeZIndex: false, dateOfInc: "", showMainModal: true, selectAll: false }

    constructor(props) {
        super(props);
        this.state = {
            currentDataIndex: 0,
            numOfChecks: [],
            zigramData: null,
            showMainModal: true
        };
    }

    handleNextData = () => {
        const dataKeys = ["pepCheck", "indianWatchlist", "sanctionCheck", "apcCheck", "unitedStatesWatchlists", "unitedKingdomWatchlists", "internationalWatchlists"];
        const nextIndex = this.state.currentDataIndex + 1;
        var selectAll = !this.state.selectAll;

        if (nextIndex < dataKeys.length) {
            this.setState({ currentDataIndex: nextIndex, numOfChecks: [], selectAll:selectAll });
        }
    };

    handlePreviousData = () => {
        const dataKeys = ["pepCheck", "indianWatchlist", "sanctionCheck", "apcCheck", "unitedStatesWatchlists", "unitedKingdomWatchlists", "internationalWatchlists"];
        const previousindex = this.state.currentDataIndex - 1;
        var selectAll = !this.state.selectAll;

        if (previousindex >= 0) {
            this.setState({ currentDataIndex: previousindex, numOfChecks: [], selectAll:selectAll });
        }
    };

    handleNextList = () => {
        const { currentListIndex } = this.state;
        if (currentListIndex < 3) { // Assuming you have 4 lists, 0-based index
            this.setState({ currentListIndex: currentListIndex + 1 });
        }
    };

    handleSelectAllChange = (currentDataKey) => {
        var selectAll = !this.state.selectAll;
        let numOfChecks = [...this.state.numOfChecks];
        var pageData = [...this.state.zigramData[currentDataKey]];
        Object.values(pageData).map((x, index) => {
            x.caseInvalid = selectAll;
            if (selectAll){
                numOfChecks.push(index);
            } else{
                const indexToRemove = numOfChecks.indexOf(index);
                numOfChecks.splice(indexToRemove, 1);
            }
        });
        this.setState({ selectAll: selectAll, numOfChecks: numOfChecks});
    }

    handleOnChange = (e, index, currentDataKey) => {

        let zigramData = this.state.zigramData;
        var pageData = [...this.state.zigramData[currentDataKey]];
        let obj = pageData[index];
        let numOfChecks = [...this.state.numOfChecks];
        if (e.target.checked) {
            obj = { ...obj, caseInvalid: true };
            numOfChecks.push(index);
        } else {
            obj = { ...obj, caseInvalid: false }
            const indexToRemove = numOfChecks.indexOf(index);
            numOfChecks.splice(indexToRemove, 1);
        }
        pageData[index] = obj;
        var zigramDataTemp = {
            ...this.state.zigramData,
            [currentDataKey]: pageData
        };
        this.setState({ zigramData: zigramDataTemp, numOfChecks: numOfChecks })
    }


    handleButton = (currentDataKey) => {
        var pageData = [...this.state.zigramData[currentDataKey]];
        let numCheckArray = [...this.state.numOfChecks];
        numCheckArray.sort((a, b) => b - a);
    
    for (let i = 0; i < numCheckArray.length; i++) {
        const indexToRemove = numCheckArray[i];
        pageData.splice(indexToRemove, 1);
    }
        pageData.forEach(item => {
            item.caseInvalid = false;
        });
        var zigramDataTemp = {
            ...this.state.zigramData,
            [currentDataKey]: pageData
        };
        this.setState({ zigramData: zigramDataTemp, numOfChecks: [], selectAll:false });

    }

    handleCloseButton = () => {
        this.setState({
            confirmModal: true,
            modalMessage: "Are you sure you wish to close ?",
            type: CLOSE
        });
    }

    handleConfirmModalButton = (type) => {
        if (type === CANCEL) {
            this.setState({
                confirmModal: false
            });
        }
        if (type === PROCEED) {
            this.setState({
                showMainModal: false,
                confirmModal: false
            });
            window.location.reload();
        }
    }

    componentDidMount() {
        if (this.props.zigramData) {
            this.setState({ zigramData: this.props.zigramData })
        }
    }

    componentDidUpdate(prevProps) {

    }


    render() {

        const { showMainModal } = this.state;
        const dataKeys = ["pepCheck", "indianWatchlist", "sanctionCheck", "apcCheck", "unitedStatesWatchlists", "unitedKingdomWatchlists", "internationalWatchlists"];
        const headerkeys = ["PEP Check", "Indian Watchlist", "Sanction Check", "Adverse Press Coverage", "US Watchlists", "UK Watchlists", "International Watchlist"];
        const currentDataKey = dataKeys[this.state.currentDataIndex];
        const currentData = this.props.zigramData[currentDataKey] || [];
        return (<React.Fragment>
            <Modal show={showMainModal} className="legal-modal Large-Modal">
                <ModalHeader className="justify-content-center">
                    Zigram Data - {headerkeys[this.state.currentDataIndex]}
                </ModalHeader>
                <ModalBody>
                    {this.state.zigramData && Object.keys(this.state.zigramData).length > 0 ? (
                        <ZigramTableView
                            tasks={Object.values(this.state.zigramData[currentDataKey])}
                            columnIndex={this.state.currentDataIndex}  // Pass columns here
                            handleOnChange={this.handleOnChange}
                            handleSelectAllChange={this.handleSelectAllChange}
                            selectAll={this.state.selectAll}
                        />
                    ) : (
                        <p>No data available.</p>
                    )}

                </ModalBody>
                <ModalFooter>
                    <Row>
                        <Col ><Button color="info" className="justify-content-center" onClick={() => this.handleCloseButton(CLOSE)} > Close </Button></Col>
                        <Col ><Button color="secondary" className="justify-content-center" onClick={this.handlePreviousData}> PREVIOUS </Button></Col>
                        <Col>
                            {currentDataKey === 'internationalWatchlists' ? (
                                <Button
                                    className="justify-content-center"
                                    onClick={() => this.props.handleSubmitZigramData(this.state.zigramData)}
                                >
                                    Submit
                                </Button>
                            ) : (
                                <Button className="justify-content-center" onClick={this.handleNextData}>
                                    Next
                                </Button>
                            )}
                        </Col>
                        <Col><Button color="danger" size="sm" className="justify-content-center" onClick={() => this.handleButton(currentDataKey)}>Delete Cases </Button></Col>
                    </Row>

                </ModalFooter>
            </Modal>
            <Modal show={this.state.confirmModal} className="legal-confirm-modal Large-Modal" >
                <ModalHeader>
                    {this.state.modalheader}
                </ModalHeader>
                <ModalBody>
                    {this.state.modalMessage}
                </ModalBody>
                <ModalFooter>
                    <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.handleConfirmModalButton(CANCEL)} > Cancel </Button></Col>
                    <Col><Button color="danger" size="lg" className="justify-content-center" onClick={() => this.handleConfirmModalButton(PROCEED)}> Proceed </Button></Col>
                </ModalFooter>
            </Modal>
        </React.Fragment>)
    }
}


const mapStateToProps = (state) => ({ legalUnprocessedData: state.legalModeration.legalUnprocessedData, legalProcessedData: state.legalModeration.legalProcessedData });

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ZigramModel);


